var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "akl" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ready,
              expression: "ready"
            }
          ],
          staticClass: "bod-view-txt"
        },
        [
          _c(
            "div",
            { staticClass: "os_noticeRes" },
            [
              _c("head-title"),
              _vm._v(" "),
              _c("head-info"),
              _vm._v(" "),
              _c("head-privacy"),
              _vm._v(" "),
              _c("apply-step", {
                attrs: { agrees: _vm.agrees, abo: _vm.abo },
                on: {
                  clickapply: _vm.apply,
                  changeagree: _vm.agree,
                  message: _vm.showlayer
                }
              }),
              _vm._v(" "),
              _c("footer-event"),
              _vm._v(" "),
              _c("div", { staticClass: "widM" }, [
                _c("div", { staticClass: "cardNews" }, [
                  _c("div", { staticClass: "card_swiper_wrap" }, [
                    _c(
                      "div",
                      { staticClass: "cardSection01" },
                      [
                        _c(
                          "swiper",
                          {
                            staticClass: "swiper-wrapper",
                            attrs: { options: _vm.swiperOption }
                          },
                          [
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_01.jpg",
                                    alt: "ARTISTRY SKIN NUTRITION"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_02.jpg",
                                    alt:
                                      "건강한 안티에이징의 시작 스킨 뉴트리션 : 시간을 멈추려면 스킨 케어만으로는 모자라니까 순간의 변화에 머무는 스킨 케어를 넘어- 깊은 곳으로 전달되는 파이토 에너지와 스킨 뉴트리션만의 독점 테크놀로지 리노베이팅 콤플렉스가 피부 스스로 피부를 지키는 힘을 키워갑니다 [ARTISTRY PHYTO-FORCE 피부 광채, 피부 정화, 탄력, 항산화, 보습 진정] &dot; 리노베이팅 콤플렉스는 뉴트리라이트 스피니치, 티 올리브 플라워, 투메릭의 조합을 의미하며, 스킨 뉴트리션 일부 제품에 함유되어 있습니다. &dot; 주름개선을 통한 안티에이징을 의미하며, 스킨 뉴트리션 일부 주름개선 기능성 화장품에 한합니다. &dot; ARTISTRY PHYTO-FORCE의 피부 효능은 소비자의 이해를 돕기 위해 대표 성분들의 효능을 기재한 것으로, 모든 원료의 효능을 대표하지 않으며, 특정 제품의 효능효과와 직접적인 관계가 없습니다."
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_03.jpg",
                                    alt:
                                      "어린 피부의 생명력을 되살리는 리뉴잉(RENEWING) #겨울에도 지지 않는 뿌리의 힘 #뿌리 에너지 [퓨리파이, 밸런스, 리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_04.jpg",
                                    alt:
                                      "리뉴잉 포밍 클렌저(RENEWING FOAMING CLEANSER) : 세정력부터 영양까지 쫀쫀하게 #밀착 클렌징 - 특별한 보습 성분이 선사하는 강력한 수분 장벽1), 5가지 자연 유래 오일의 깊은 영양2), 클렌징 후에도 당김 없는 탄력감 1) 히알루론산, 트레할로오스 / 원료적 효능에 한함 2) 멕시칸치아씨오일, 들깨오일, 달맞이꽃오일, 돌콩오일, 해바라기씨오일 / 원료적 효능에 한함 [퓨리파이]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_05.jpg",
                                    alt:
                                      "리뉴잉 소프트닝 토너(RENEWING SOFTENING TONER) : 귀리 단백질이 선사하는 탄탄한 피부 #에센스 토너 - 자연 유래 귀리 단백질이 매끈하게 피부결 정돈1), 락토바실러스 발효물이 피부 기본기를 탄탄하게2), 풍부한 영양의 즉각적인 보습과 윤기 1), 2) 원료적 효능에 한함 [밸런스]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_06.jpg",
                                    alt:
                                      "리뉴잉 리액티베이션 아이 크림(RENEWING REACTIVATION EYE CREAM) : 눈가 피부를 깊이 이해한 토탈 안티에이징 솔루션 #아이 버터 - 눈에 띄는 잔주룸, 깊은 주름, 꺼진 탄력, 어두운 피부 빛까지 한 번에, 세라마이드가 선사하는 24시간 강력 보습막, 피부에 닿는 순간 녹아드는 쫀쫀한 버터 텍스처 [리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_07.jpg",
                                    alt:
                                      "리뉴잉 밀키 에멀전(RENEWING MILKY EMULSION) : 속부터 채워지는 강력한 영양 #탄력 부스팅 로션 - 하루 두 번 자연의 강력한 항산화제, 비타민 E 충전1), 차세대 보습 성분 스쿠알란의 피부 수분 장벽 보호2), 끈적임 없이 탄력을 남기는 고보습 제형 1), 2) 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_08.jpg",
                                    alt:
                                      "리뉴잉 리액티베이션 크림(RENEWING REACTIVATION CREAM) : 젊은 피부의 기억을 되살리는 #뿌리 에너지 크림 - 사용 15분 후 피부 주름 8.6%, 피부 빛 59% 개선1), 겨울에도 지지 않는 맥문동, 강황 뿌리의 강력한 항산화력2), 빠르고 매끄럽게 스며드는 풍부한 영양감의 텍스처 1) AIM Lab, n=39 2) 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_09.jpg",
                                    alt:
                                      "긴 세월의 흔적마저 깊이 잠재우는 퍼밍(FIRMING) #빈틈 없는 탄성감 #쓰면 쓸수록* 올라가는 탄력! *한 달 사용 기준 [퓨리파이, 밸런스, 리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "swiper-slide",
                              { staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    "max-width": "500px"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_10.jpg",
                                    alt:
                                      "퍼밍 울트라 리프팅 크림(FIRMING ULTRA LIFTING CREAM) : 쓰면 쓸수록1) 극강의 탄력을 선사하는 #울트라 리프팅 크림 - 사용 2주 후, 피부탄력 14.2% 개선, 사용 4주 후, 피부탄력 26.0% 개선2), 피부 자생력을 강화시키는 발효 에너지3), 짙은 노화의 흔적을 채워주는 빈틈 없는 탄성감 1) 한 달 사용 기준 2)AIM Lab, n=33 3) 효모/자일리눔/홍차발효물, 보리추출물, 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "swiper-pagination",
                              attrs: { slot: "pagination" },
                              slot: "pagination"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "swiper-button-prev",
                              attrs: { slot: "button-prev" },
                              slot: "button-prev"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "swiper-button-next",
                              attrs: { slot: "button-next" },
                              slot: "button-next"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("footer-consumer")
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("popup-message", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.messagetype != 0,
            expression: "messagetype !=  0"
          }
        ],
        attrs: { message: _vm.messages, type: _vm.messagetype },
        on: { close: _vm.closelayer }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76bc96f0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bc96f0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/relayevent.vue
// module id = null
// module chunks = 